import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=d6d0c830&scoped=true&"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js&"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=d6d0c830&scoped=true&lang=css&"
import style1 from "./TermsAndCondition.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d0c830",
  null
  
)

export default component.exports